import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivate, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { RoleGuard } from './guards/role.guard';
import { Home } from './components/home/home.component';
import { PaymentCenterComponent } from './components/payment-center/payment-center.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';

const redirectUnauthorized = () => redirectUnauthorizedTo(['dang-nhap']);
const redirectLoggedIn = () => redirectLoggedInTo(['trang-chu']);

const routes: Routes = [
  // Các route auth
  {
    path: 'dang-ky',
    loadComponent: () => import('./components/registration/registration.component').then(m => m.RegistrationComponent),
    ...canActivate(redirectLoggedIn),
  },
  {
    path: 'dang-nhap',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    ...canActivate(redirectLoggedIn),
  },
  { path: 'login', redirectTo: 'dang-nhap', pathMatch: 'full' },
  { path: 'registration', redirectTo: 'dang-ky', pathMatch: 'full' },

  // Trang chủ (không lazy load) - Public
  { path: '', component: Home, pathMatch: 'full' },
  { path: 'home', component: Home },

  {
    path: 'farm',
    loadComponent: () => import('./components/farm/farm.component').then(m => m.FarmComponent),
  },

  // Payment Center - Chỉ cho role paymentcenter
  {
    path: 'payment-center',
    component: PaymentCenterComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paymentcenter'] }
  },
  {
    path: 'payment-success',
    component: PaymentSuccessComponent,
    ...canActivate(redirectUnauthorized),
  },
  {
    path: 'payment-cancel',
    redirectTo: '/payment-center',
    pathMatch: 'full'
  },

  // Nhà thuốc tổng - Chỉ cho role pharmacy
  {
    path: 'nhaThuocTong',
    loadComponent: () => import('./components/nhaThuocTong/nhaThuocTong.component').then(m => m.NhaThuocTong),
    canActivate: [RoleGuard],
    data: { roles: ['pharmacy'] }
  },

  // Phòng xét nghiệm - Chỉ cho role labhouse
  {
    path: 'labhouse',
    loadComponent: () => import('./components/labhouse/labhouse.component').then(m => m.LabhouseComponent),
    canActivate: [RoleGuard],
    data: { roles: ['labhouse'] }
  },

  // Quản lý hồ sơ - Chỉ cho role csyt (cơ sở y tế)
  {
    path: 'quanLyHoSo',
    loadComponent: () => import('./components/quanLyHoSo/quanLyHoSo.component').then(m => m.QuanLyHoSo),
    canActivate: [RoleGuard],
    data: { roles: ['csyt'] }
  },

  // Khách mua đơn thuốc - Public (không cần role đặc biệt)
  {
    path: 'khachMuaDonThuoc',
    loadComponent: () => import('./components/khachMuaDonThuoc/khachMuaDonThuoc.component').then(m => m.KhachMuaDonThuoc),
  },

  // Quản lý thành viên - Yêu cầu đăng nhập (có thể thêm role nếu cần)
  {
    path: 'quanLyThanhVien',
    loadComponent: () => import('./components/quanLyThanhVien/quanLyThanhVien.component').then(m => m.QuanLyThanhVien),
    ...canActivate(redirectUnauthorized),
    // Có thể thêm role guard nếu muốn giới hạn quyền truy cập:
    // canActivate: [RoleGuard],
    // data: { roles: ['admin', 'csyt'] }
  },

  // Audit - Yêu cầu đăng nhập (có thể thêm role nếu cần)
  {
    path: 'audit/:id',
    loadComponent: () => import('./components/audit/audit.component').then(m => m.AuditComponent),
    ...canActivate(redirectUnauthorized),
    // Có thể thêm role guard nếu muốn giới hạn quyền truy cập:
    canActivate: [RoleGuard],
    data: { roles: ['auditer'] }
  },

  // Trang không có quyền truy cập
  {
    path: 'unauthorized',
    loadComponent: () => import('./components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },

  { path: 'trang-chu', redirectTo: '', pathMatch: 'full' },

  // Trang 404
  {
    path: '**',
    loadComponent: () => import('./components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }